import { Platform } from '@eika-infrastruktur/mobilbank-lib';

import type { CreatePushDeviceRequest, PlatformOS, PushDeviceResponse } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { del, get, post } from './request';

export const platformMapper = (platform: Platform): PlatformOS | 'unknown' => {
    switch (platform) {
        case 'android':
            return 'android';
        case 'ios':
            return 'ios';
        case 'web':
            return 'web';
        default:
            return 'unknown';
    }
};

const SERVICE_PATH = 'rest/resource/pushdevice';
export const createPushDevice = (payload: CreatePushDeviceRequest) => post(`${CONTEXT_PATH}/${SERVICE_PATH}`, payload);

export const getPushDevice = (): Promise<PushDeviceResponse> =>
    get<PushDeviceResponse>(`${CONTEXT_PATH}/${SERVICE_PATH}`);

export const deactivatePushDevice = () => del<void>(`${CONTEXT_PATH}/${SERVICE_PATH}`);
